import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgPaymentWallet(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M60.84 43.455 43.334 70.768a3.98 3.98 0 0 0 1.203 5.498L75.507 96.12a3.98 3.98 0 0 0 5.498-1.203l17.508-27.313a3.98 3.98 0 0 0-1.203-5.498L66.34 42.253a3.98 3.98 0 0 0-5.498 1.202Z"
        fill="#78B441"
      />
      <path
        d="M83.52 37.12 34.161 23.893a3.98 3.98 0 0 0-4.874 2.814L20.288 60.29a3.98 3.98 0 0 0 2.814 4.874l49.358 13.225a3.98 3.98 0 0 0 4.874-2.814l8.999-33.582a3.98 3.98 0 0 0-2.815-4.874Z"
        fill="#F1F5F9"
      />
      <path
        d="m34.162 23.894 49.357 13.225a3.981 3.981 0 0 1 2.814 4.874l-1.238 4.62L28.05 31.329l1.239-4.62a3.981 3.981 0 0 1 4.874-2.814Z"
        fill="#78B441"
      />
      <path
        d="m30.627 39.04-5.254 19.58a2.388 2.388 0 0 0 1.687 2.925l16.828 4.515a2.388 2.388 0 0 0 2.925-1.687l5.254-19.58a2.388 2.388 0 0 0-1.688-2.925l-16.827-4.516a2.388 2.388 0 0 0-2.925 1.688Z"
        fill="#A6DBCB"
      />
      <path
        d="M30.01 57.934a6.442 6.442 0 0 1 7.903-4.557 6.442 6.442 0 0 1 4.557 7.904l-1.123 4.19-12.47-3.342L30 57.94l.01-.005ZM38.108 52.68a3.582 3.582 0 1 0 1.854-6.92 3.582 3.582 0 0 0-1.854 6.92Z"
        fill="#00664F"
      />
      <path
        d="M78.395 50.772a.8.8 0 0 1-.414 1.545L56.123 46.46a.8.8 0 1 1 .414-1.545l21.858 5.857Z"
        fill="#78B441"
      />
      <path
        d="M64.658 68.64a.8.8 0 0 1-.413 1.544l-13.51-3.612a.8.8 0 1 1 .413-1.545l13.51 3.612ZM74.126 66.702a.8.8 0 0 1-.413 1.545l-21.86-5.85a.8.8 0 1 1 .414-1.544l21.859 5.849ZM75.243 62.535a.8.8 0 0 1-.414 1.545l-21.858-5.857a.8.8 0 1 1 .414-1.545l21.858 5.857ZM77.276 54.947a.8.8 0 0 1-.414 1.545l-21.857-5.857a.8.8 0 1 1 .413-1.545l21.858 5.857Z"
        fill="#B3C0D0"
      />
      <path
        d="M24.529 15.91a.8.8 0 0 1 1.125.113l3.62 4.422a.8.8 0 0 1-1.238 1.013l-3.62-4.422a.8.8 0 0 1 .113-1.126ZM33.185 14.361a.8.8 0 0 1 .968.586l.93 3.785a.8.8 0 1 1-1.553.382l-.93-3.784a.8.8 0 0 1 .585-.969ZM21.017 23.297a.8.8 0 0 1 1.073-.36l3.447 1.716a.8.8 0 1 1-.713 1.431l-3.447-1.714a.8.8 0 0 1-.36-1.073Z"
        fill="#0F172A"
      />
      <path
        d="m41.965 51.831-8.97 33.475a3.98 3.98 0 0 0 2.814 4.874l49.704 13.318a3.98 3.98 0 0 0 4.874-2.814l8.97-33.474a3.98 3.98 0 0 0-2.814-4.874L46.839 49.017a3.98 3.98 0 0 0-4.874 2.814Z"
        fill="#78B441"
      />
      <path
        d="M98.576 67a3.181 3.181 0 0 0-2.248-3.894L46.623 49.788a3.181 3.181 0 0 0-3.895 2.248.8.8 0 1 1-1.545-.414 4.78 4.78 0 0 1 5.854-3.38l49.704 13.319a4.781 4.781 0 0 1 3.38 5.853.8.8 0 0 1-1.546-.414Z"
        fill="#0F172A"
      />
      <path
        d="m39.83 62.845 11.086 2.97a6.14 6.14 0 0 1 4.339 7.516 6.14 6.14 0 0 1-7.516 4.34L36.653 74.7a2.385 2.385 0 0 1-1.689-2.925l1.939-7.234a2.385 2.385 0 0 1 2.924-1.688l.002-.008Z"
        fill="#007A5F"
      />
      <path
        d="M49.495 74.317a2.444 2.444 0 1 0 1.264-4.72 2.444 2.444 0 0 0-1.264 4.72Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgPaymentWallet)
